import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonCheckbox, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { addCircleOutline, removeCircleOutline } from 'ionicons/icons';

@Component({
  selector: 'app-slip-item-choice-actions',
  templateUrl: './slip-item-choice-actions.component.html',
  styleUrls: ['./slip-item-choice-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonCheckbox, IonIcon, IonButton]
})
export class SlipItemChoiceActionsComponent {
  @Input() checkboxMode: boolean;
  @Input() itemCount: number;
  @Input() addEnabled: boolean;
  @Input() choiceLimit: number;
  @Input() sharedAvailability: { limit: number; remaining: number };
  @Output() choiceChanged = new EventEmitter<number>();

  constructor() {
    addIcons({ addCircleOutline, removeCircleOutline });
  }

  onAdd(): void {
    this.itemCount++;
    this.choiceChanged.emit(this.itemCount);
  }
  onRemove(): void {
    this.itemCount--;
    this.choiceChanged.emit(this.itemCount);
  }

  onCheck(): void {
    if (!this.canAdd) return;
    if (this.itemCount === 1) this.itemCount--;
    else this.itemCount++;
    this.choiceChanged.emit(this.itemCount);
  }

  get limitReached(): boolean {
    return !!this.choiceLimit && this.itemCount >= this.choiceLimit;
  }
  get sharedAvailabilityReached(): boolean {
    return !!this.sharedAvailability && this.sharedAvailability.remaining <= 0;
  }

  get limitCaption(): string {
    if (this.sharedAvailabilityReached) return `shared availability reached (${this.sharedAvailability.limit})`;
    if (this.limitReached) return 'Limit reached';
    if (this.choiceLimit > 0) return 'Limit: ' + this.choiceLimit;
    return '';
  }

  get canAdd(): boolean {
    return this.addEnabled && (this.checkboxMode || !this.limitReached);
  }

  get canRemove(): boolean {
    return this.itemCount > 0;
  }
}
